export class Convert {
  public static newDateZeroes() {
    let now = new Date();
    now.setHours(0, 0, 0, 0);
    return now;
  }

  public static treatDateJSON(dateFatura: string): Date {
    if (dateFatura.length < 16) dateFatura += ' 00:00:00';
    else dateFatura = dateFatura.replace('Z', '');
    return new Date(dateFatura);
  }

  public static formatCurrencyBrazil(value: string): string {
    let price: number = Number(value.trim());
    return price.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).trim();
  }

  public static dateStringToBrazil(date: string): string {
    return this.treatDateJSON(date).toLocaleDateString('pt-BR');
  }
}
